import { CallbackTypes } from './constants';
var CallbackFn = new Map();

/**
 * Registers a singleton callback function  This callback is used whenever the app wants to convey a status or logging event back to the consumer.
 * @param {Callback} callback a callback function
 * @param {Namespace} namespace a namespace to identify the callback function
 * @returns {void}
 */
export var setCallback = function setCallback(callback, namespace) {
  CallbackFn.set(namespace, callback);
};

/**
 * Called whenever you need to send callback data to the consumer
 * @param {StatusUpdate[]} data Callback object to be sent back to the registered callback function
 * @param {Namespace} namespace a namespace to identify the callback function
 * @returns {void}
 */
export var fireStatusUpdate = function fireStatusUpdate(data, namespace) {
  var callback = CallbackFn.get(namespace);
  callback && callback({
    callbackType: CallbackTypes.STATUS_UPDATE,
    data: data
  });
};

/**
 * Called whenever the you need to send a log event to the consumer
 * @param {LoggingEvent} data the logging event to be sent into the callback function
 * @param {Namespace} namespace a namespace to identify the callback function
 * @returns {void}
 */
export var fireLogEvent = function fireLogEvent(data, namespace) {
  var callback = CallbackFn.get(namespace);
  callback && callback({
    callbackType: CallbackTypes.LOG_EVENT,
    data: data
  });
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/utils/CallbackUtils/index.js
// module id = 632
// module chunks = 11